import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Features } from '../../../featureToggles/features';
import { IPreviewEnterpriseLicenseCost } from './interfaces';
import { fetchPreviewEnterpriseLicenseCost } from './thunk';
import { BlockedByFeature, BlockedByFeatureType, notAvailablePropExceptIn } from '../../../featureToggles/features/utils';
import { ApiError } from '../../../services/api';

export interface IPreviewEnterpriseLicenseCostState {
  loading: boolean;
  error: ApiError | undefined;
  licenseCost: IPreviewEnterpriseLicenseCost | undefined;
}

export type IPreviewEnterpriseLicenseCostStatePlgExternal3 = IPreviewEnterpriseLicenseCostState | BlockedByFeatureType;

const initialState: IPreviewEnterpriseLicenseCostStatePlgExternal3 = notAvailablePropExceptIn({
  expected: {
    loading: false,
    error: undefined,
    licenseCost: undefined
  },
  availableIn: [Features.PlgExternal3]
});

const previewEnterpriseLicenseCostSlice = createSlice({
  name: 'previewEnterpriseLicenseCost',
  initialState,
  reducers: {
    resetValues: (state: IPreviewEnterpriseLicenseCostStatePlgExternal3): IPreviewEnterpriseLicenseCostStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      return {
        loading: false,
        error: undefined,
        licenseCost: undefined
      };
    }
  },
  extraReducers: {
    [fetchPreviewEnterpriseLicenseCost?.pending.type]: (state: IPreviewEnterpriseLicenseCostStatePlgExternal3): IPreviewEnterpriseLicenseCostStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = true;
      state.error = undefined;
      return state;
    },
    [fetchPreviewEnterpriseLicenseCost?.fulfilled.type]: (state: IPreviewEnterpriseLicenseCostStatePlgExternal3, action: PayloadAction<IPreviewEnterpriseLicenseCost>): IPreviewEnterpriseLicenseCostStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      if (!action.payload) {
        return state;
      }
      state.loading = false;
      state.error = undefined;
      state.licenseCost = action.payload;
      return state;
    },
    [fetchPreviewEnterpriseLicenseCost?.rejected.type]: (state: IPreviewEnterpriseLicenseCostStatePlgExternal3, action: PayloadAction<ApiError>): IPreviewEnterpriseLicenseCostStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      if (typeof action.payload === 'object' && action.payload.message) {
        state.error = action.payload;
      }
      return state;
    }
  }
});

export const actions = {
  ...previewEnterpriseLicenseCostSlice.actions
};

export default previewEnterpriseLicenseCostSlice.reducer;
